<div class="hero-dark"></div>
<div class="container">
  <div class="flex flex-column md:flex-row align-items-center md:justify-content-between">
    <div class="my-2">
      <div class="flex align-items-center gap-2">
        <h1>Sei pronto a partire?</h1>
        @if (environment.debug) {
        <pre>{{ checkout_type }}</pre>
        }
        <img src="assets/media/icons/airplane.png" height="40" />
      </div>
      <h3 class="mt-0">
        Completa la tua <span class="green">prenotazione</span>!
      </h3>
    </div>
    <div class="screen breadcrumb-container flex align-items-center">
      <p-breadcrumb [model]="items" />
    </div>
  </div>
  @if (invitation) {
  @if (notRightUser) {
  <div class="bg-muted-t alert-in-page mb-3">
    <div class="flex align-items-center gap-3">
      <p-avatar [image]="
              invitation.from_user.profile_picture | imagePipe: 'user-w' : 'sm'
            " shape="circle" size="large"></p-avatar>
      <div class="flex flex-column gap-1">
        <strong>{{ invitation.from_user.name }} ti ha invitato a
          partecipare!</strong>
        <small>Effettua il <a href="/login" class="clickable">login</a> e
          ritorna su questa pagina per poter accettare l'invito.</small>
      </div>
    </div>
  </div>
  } @else {
  <div class="bg-muted-t alert-in-page mb-3">
    <div class="flex align-items-center gap-3">
      <p-avatar [image]="
              invitation.from_user.profile_picture | imagePipe: 'user-w' : 'sm'
            " shape="circle" size="large"></p-avatar>
      <div class="flex flex-column gap-1">
        <strong>{{ invitation.from_user.name }} ti ha invitato a
          partecipare!</strong>
        <small>Compila i campi qui sotto e segui le istruzioni per partecipare a
          questo viaggio!</small>
      </div>
    </div>
  </div>
  }
  }
</div>

@if (loading) {
<div class="backdrop-mini-loader">
  <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
</div>
} @else {
@if (travel) {
<div [ngClass]="{ disabled: notRightUser }">
  <div class="bg-t p-3">
    <div class="flex align-items-center justify-content-between md:justify-content-center">
      <div class="step-box flex align-items-center justify-content-between">
        <div class="dotted-line"></div>
        <span class="pr-2" [ngClass]="{ active: menuIndex === 0 }" (click)="goTo(0)">• Dati della prenotazione</span>
        <span class="pl-2" [ngClass]="{
                active: menuIndex === 1,
                txt_disabled:
                  frmRooms.invalid ||
                  maxMembersExceeded ||
                  (travel.pricing_mode === 2 && isPaymentDisabled),
              }" (click)="goTo(1)">•
          {{
          frmJoin.get("third_party_booking")?.value
          ? "Registrazione"
          : (travel.gmg_finalized_on ? "Conferma prenotazione" : "Pagamento")
          }}</span>
      </div>
    </div>
  </div>

  <div class="container mb-6">
    <form [formGroup]="frmJoin">
      @switch (menuIndex) {
      @case (0) {
      <div class="mt-4">
        <div class="grid grid-container">
          <div class="col-12 md:col-12 lg:col-8 md:pr-5">
            <h1>{{ travel.name }}</h1>
            @if (travel.has_flights === true) {
            <div class="mt-5 form-section mb-4">
              <div class="grid" [ngClass]="[
                            purchased_with_optional_flight.value === true
                              ? 'disabled'
                              : '',
                          ]">
                <div class="col-12 md:col-6 lg:col-6">
                  <strong>Andata</strong>
                  @for (d of travel.departures; track $index) {
                  <div class="flex align-items-start gap-3 mt-3">
                    <img src="/assets/media/icons/going.png" height="30" />
                    <div class="flex flex-column gap-1">
                      <span><strong>{{
                          d.flight.flight_company?.name
                          }}</strong>
                        <br />
                        {{ d.flight.from_airport?.name }} ({{
                        d.flight.from_airport?.code
                        }}) » {{ d.flight.to_airport?.name }} ({{
                        d.flight.to_airport?.code
                        }})</span>
                      <small>{{
                        d.flight.departure_date
                        | date: "dd/MM/yyyy, HH:mm"
                        }}
                        »
                        {{
                        d.flight.arrival_date
                        | date: "dd/MM/yyyy, HH:mm"
                        }}</small>
                    </div>
                  </div>
                  }
                </div>
                <div class="col-12 md:col-6 lg:col-6">
                  <strong>Ritorno</strong>
                  @for (a of travel.arrivals; track $index) {
                  <div class="flex align-items-start gap-3 mt-3">
                    <img src="/assets/media/icons/going-back.png" height="30" />
                    <div class="flex flex-column gap-1">
                      <span><strong>{{
                          a.flight.flight_company?.name
                          }}</strong>
                        <br />{{ a.flight.from_airport?.name }} ({{
                        a.flight.from_airport?.code
                        }}) » {{ a.flight.to_airport?.name }} ({{
                        a.flight.to_airport?.code
                        }})</span>
                      <small>{{
                        a.flight.departure_date
                        | date: "dd/MM/yyyy, HH:mm"
                        }}
                        »
                        {{
                        a.flight.arrival_date
                        | date: "dd/MM/yyyy, HH:mm"
                        }}</small>
                    </div>
                  </div>
                  }
                </div>
              </div>
              @if (travel.optional_flight_purchase) {
              <div class="highlighted-flight-alert flex flex-column gap-1 mt-4">
                <span>Questo viaggio è acquistabile senza voli!
                  <small class="grey-text">(-{{
                    travel.optional_flight_purchase_discount
                    | currency
                    : travel.currency
                    : "symbol"
                    : ".2-2"
                    }}
                    sul totale)</small></span>
                <div class="flex align-items-center gap-3 mt-4">
                  <p-inputSwitch [formControl]="purchased_with_optional_flight" inputId="flight" />
                  <label for="flight" class="text-sm mb-1">Desidero acquistare il viaggio senza
                    volo.</label>
                </div>
              </div>
              }
            </div>
            }
            @if (travel.pricing_mode != 2) {
            <div class="form-section mb-4" [ngClass]="travel.has_flights === false ? 'mt-5' : ''">
              @if (maxMembersExceeded) {
              <div class="muted-r-bg alert-in-page mb-6 w-full">
                <div class="flex align-items-center flex-wrap gap-3">
                  <img src="/assets/media/icons/alert-g.png" width="40" />
                  <div class="flex flex-column gap-1">
                    <strong class="text-base">Solo
                      {{
                      travel.max_members -
                      travel.availability?.booked!
                      | availabilityPluralPipe
                      }}</strong>
                    <small>Riduci il numero degli adulti per poter
                      partecipare.</small>
                  </div>
                </div>
              </div>
              }
              @if (isGuest) {
              <b>Seleziona il numero di ospiti:</b>
              } @else {
              <strong>Seleziona le camere:</strong>
              }
              @for (
              r of frmRoomsControls;
              track $index;
              let roomIndex = $index
              ) {
              <div class="grid" [formGroup]="r">
                <div class="col">
                  <div class="mt-3">
                    <label>Adulti</label>
                    <div class="mt-1 select-button-box">
                      <p-selectButton [options]="adult_customers" formControlName="n_adults"
                        (onChange)="checkForAvailability()" />
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="mt-3">
                    <label>Bambini (2-8 anni)</label>
                    <div class="mt-1 select-button-box">
                      <p-selectButton [options]="kid_customers" formControlName="n_children" />
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="mt-3">
                    <label>Neonati (fino a 2 anni)</label>
                    <div class="mt-1 select-button-box">
                      <p-selectButton [options]="kid_customers" formControlName="n_infants" />
                    </div>
                  </div>
                </div>
                @if (frmRoomsControls.length > 1) {
                <div class="col-1">
                  <div class="h-full flex align-items-end justify-content-center">
                    <p-button [text]="true" icon="pi pi-trash" size="small"
                      (click)="remove($index, frmRooms)"></p-button>
                  </div>
                </div>
                }
                <div class="col-12">
                  @if (!isGuest) {
                  <div class="mt-3 border-b">
                    @if (r.get("n_adults")?.value === 2) {
                    <div class="flex align-items-center gap-3">
                      <div class="flex align-items-center gap-1 mt-4">
                        <p-radioButton formControlName="dbl_type" [inputId]="'double_bed' + $index" [value]="1" />
                        <label [for]="'double_bed' + $index" class="text-sm mb-1">Matrimoniale</label>
                      </div>
                      <div class="flex align-items-center gap-2 mt-4">
                        <p-radioButton formControlName="dbl_type" [inputId]="'single_bed' + $index" [value]="2" />
                        <label [for]="'single_bed' + $index" class="text-sm mb-1">Doppia</label>
                      </div>
                    </div>
                    } @else {
                    <div class="mt-4">
                      <h4>
                        {{
                        r.get("room_type")?.value
                        | roomTypePipe
                        }}
                      </h4>
                    </div>
                    }
                  </div>
                  }
                  <div class="mt-4 accordion-box" [ngClass]="maxMembersExceeded ? 'disabled' : ''">
                    <p-accordion [activeIndex]="activeIndex">
                      @for (
                      m of getFrmMembersControls($index);
                      track $index;
                      let memberIndex = $index
                      ) {
                      <p-accordionTab>
                        <ng-template pTemplate="header">
                          <h4>
                            Dati partecipante
                            {{ memberIndex + 1 }}
                            @if ($index === 0 && !isGuest) {
                            (intestatario pratica)
                            }
                          </h4>
                        </ng-template>
                        <ng-template pTemplate="content">
                          <div class="grid" [formGroup]="m">
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Nome</label>
                                <input type="text" pInputText class="w-full mt-1" formControlName="name" />
                                @if (
                                m.get("name")?.errors &&
                                m.get("name")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('name')?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Cognome</label>
                                <input type="text" pInputText class="w-full mt-1" formControlName="last_name" />
                                @if (
                                m.get("last_name")?.errors &&
                                m.get("last_name")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('last_name')?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Data di nascita</label>
                                <p-calendar ngClass="w-full frm" [readonlyInput]="true" appendTo="body"
                                  panelStyleClass="custom-calendar" [touchUI]="false" [maxDate]="today"
                                  formControlName="date_of_birth" dateFormat="dd/mm/yy"
                                  [firstDayOfWeek]="1"></p-calendar>
                                @if (
                                m.get("date_of_birth")
                                ?.errors &&
                                m.get("date_of_birth")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('date_of_birth')
                                                      ?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Genere</label>
                                <p-dropdown [options]="genders" optionValue="id" optionLabel="name" ngClass="w-full frm"
                                  placeholder="Scegli" formControlName="gender"></p-dropdown>
                                @if (
                                m.get("gender")?.errors &&
                                m.get("gender")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('gender')?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <!-- <div class="col-12 md:col-4">
                                                          <div class="mt-3">
                                                              <label>Codice fiscale</label>
                                                              <input type="text" pInputText class="w-full mt-1"
                                                                  formControlName="fiscal_code" />
                                                              @if(m.get('fiscal_code')?.errors &&
                                                              m.get('fiscal_code')?.dirty){
                                                              <st-errors
                                                                  [errors]="m.get('fiscal_code')?.errors"></st-errors>
                                                              }
                                                          </div>
                                                      </div> -->
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Telefono</label>
                                <input type="text" pInputText class="w-full mt-1" formControlName="phone_number" />
                                @if (
                                m.get("phone_number")?.errors &&
                                m.get("phone_number")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('phone_number')
                                                      ?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Email</label>
                                <input type="text" pInputText class="w-full mt-1" formControlName="email_address" />
                                @if (
                                m.get("email_address")
                                ?.errors &&
                                m.get("email_address")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('email_address')
                                                      ?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Cittadinanza</label>
                                <input type="text" pInputText class="w-full mt-1" formControlName="nationality" />
                                @if (
                                m.get("nationality")?.errors &&
                                m.get("nationality")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('nationality')?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Tipo di documento</label>
                                <p-dropdown [options]="id_type" optionValue="id" optionLabel="name" ngClass="w-full frm"
                                  placeholder="Scegli" formControlName="document_type"></p-dropdown>
                                @if (
                                m.get("document_type")
                                ?.errors &&
                                m.get("document_type")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('document_type')
                                                      ?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Scadenza documento</label>
                                <p-calendar ngClass="w-full frm" [firstDayOfWeek]="1"
                                  formControlName="document_exp_date" [readonlyInput]="true" appendTo="body"
                                  [minDate]="today" panelStyleClass="custom-calendar" [touchUI]="false"
                                  dateFormat="dd/mm/yy"></p-calendar>
                                @if (
                                m.get("document_exp_date")
                                ?.errors &&
                                m.get("document_exp_date")
                                ?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('document_exp_date')
                                                      ?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Data emissione documento</label>
                                <p-calendar ngClass="w-full frm" [firstDayOfWeek]="1"
                                  formControlName="document_release_date" [readonlyInput]="true" appendTo="body"
                                  [maxDate]="today" panelStyleClass="custom-calendar" [touchUI]="false"
                                  dateFormat="dd/mm/yy"></p-calendar>
                                @if (
                                m.get("document_release_date")
                                ?.errors &&
                                m.get("document_release_date")
                                ?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get(
                                                      'document_release_date'
                                                    )?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <label>Numero documento</label>
                                <input type="text" pInputText class="w-full mt-1" formControlName="document_number" />
                                @if (
                                m.get("document_number")
                                ?.errors &&
                                m.get("document_number")?.dirty
                                ) {
                                <st-errors [errors]="
                                                    m.get('document_number')
                                                      ?.errors
                                                  "></st-errors>
                                }
                              </div>
                            </div>
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <div class="flex align-items-center gap-2 mt-6">
                                  <p-inputSwitch formControlName="disabled" inputId="disabled" />
                                  <label for="disabled" class="text-sm mb-1">Disabile</label>
                                </div>
                              </div>
                            </div>
                            @if (isGuest) {
                            <!-- <div class="col-12 md:col-4">
                                                          <div class="mt-3">
                                                              <div class="flex align-items-center gap-2 mt-6"
                                                                  (click)="checkHolderGuest($index)">
                                                                  <p-inputSwitch [formControl]="account_holder_guest"
                                                                      inputId="holder" />
                                                                  <label for="holder" class="text-sm mb-1">Intestatario
                                                                      pratica</label>
                                                              </div>
                                                          </div>
                                                      </div> -->
                            <div class="col-12 md:col-4">
                              <div class="mt-3">
                                <div class="flex align-items-center gap-2 mt-6">
                                  <p-inputSwitch formControlName="tmp_account_holder_guest" inputId="holder{{
                                                      roomIndex
                                                    }}{{ memberIndex }}" (onChange)="
                                                      checkHolderGuest(
                                                        roomIndex,
                                                        memberIndex
                                                      )
                                                    " />
                                  <label for="holder{{ roomIndex }}{{
                                                      memberIndex
                                                    }}" class="text-sm mb-1">
                                    Intestatario pratica
                                  </label>
                                </div>
                              </div>
                            </div>
                            }
                          </div>
                        </ng-template>
                      </p-accordionTab>
                      }
                    </p-accordion>
                  </div>
                </div>
              </div>
              }
              @if (!isGuest) {
              <div class="out-green flex align-items-center mt-4">
                <p-button [outlined]="true" label="Aggiungi una camera" size="small" (click)="addRoom()"
                  styleClass="px-6" [disabled]="maxMembersExceeded"></p-button>
              </div>
              }
            </div>
            } @else {
            <b>Seleziona i pacchetti che desideri acquistare:</b>
            <!--PACCHETTI-->
            @for (
            p of travel.price_packages;
            track $index;
            let pkgIndex = $index
            ) {
            <div class="mt-5">
              <p-accordion [multiple]="false">
                <p-accordionTab (selected)="(expandedTabIndex === pkgIndex)"
                  (selectedChange)="onTabToggle(pkgIndex, $event)">
                  <!-- HEADER -->
                  <ng-template pTemplate="header">
                    <div class="flex flex-column gap-2 w-full">
                      <div class="w-full flex justify-content-between align-items-center gap-3">
                        <h3 class="m-0">{{ p.name }}</h3>
                        <h2 class="green m-0">
                          {{
                          p.price_per_person
                          | currency
                          : travel.currency
                          : "symbol"
                          : ".2-2"
                          }}
                        </h2>
                      </div>
                      <div class="grey-text p-0 font-normal" [ngClass]="{
                                      'description-truncated':
                                        expandedTabIndex !== pkgIndex,
                                    }" [innerHTML]="p.description"></div>
                    </div>
                  </ng-template>
                  <!-- CONTENT -->
                  <ng-template pTemplate="content">
                    <div class="flex flex-column gap-2">
                      <div class="flex align-items-center gap-1">
                        <img src="/assets/media/icons/check-g.png" height="18" />
                        <small>Ideato per
                          <b>{{ p.n_partecipants }}</b>
                          adult{{
                          p.n_partecipants > 1 ? "i" : "o"
                          }}.</small>
                      </div>
                      @if (
                      p.max_n_children > 0 && p.max_n_infants > 0
                      ) {
                      <div class="flex align-items-center gap-1">
                        <img src="/assets/media/icons/check-g.png" height="18" />
                        <small>Numero massimo di bambini (2-8 anni)
                          ammessi: <b>{{ p.max_n_children }}</b>.</small>
                      </div>
                      <div class="flex align-items-center gap-1">
                        <img src="/assets/media/icons/check-g.png" height="18" />
                        <small>Numero massimo di neonati (0-2 anni)
                          ammessi: <b>{{ p.max_n_infants }}</b>.</small>
                      </div>
                      }
                      @if (p.limited) {
                      <small class="orange">Questo pacchetto ha un numero limitato di
                        prenotazioni disponibili!</small>
                      }
                    </div>

                    @if (getPackageControls(p.id).length > 0) {
                    @for (
                    sp of getPackageControls(p.id).controls;
                    track $index;
                    let purchaseIndex = $index
                    ) {
                    <form [formGroup]="sp">
                      <div class="grid mt-4">
                        <div class="col-12 flex justify-content-between align-items-center">
                          <div class="flex align-items-center gap-2">
                            <h4 class="green m-0">
                              Acquisto #{{ $index + 1 }}
                            </h4>
                          </div>
                          <div class="flex out-green">
                            <p-button (click)="
                                                removePurchase(
                                                  pkgIndex,
                                                  purchaseIndex
                                                )
                                              " label="Rimuovi" size="small" styleClass="px-6"
                              [outlined]="true"></p-button>
                          </div>
                        </div>
                        <div class="col-4">
                          <div class="partecipants-box adults px-3 py-2">
                            <label>Adulti</label>
                            <h3 class="m-0">
                              {{ p.n_partecipants }}
                            </h3>
                          </div>
                        </div>
                        @if (
                        p.max_n_children > 0 &&
                        p.max_n_infants > 0
                        ) {
                        <div class="col-4">
                          <!-- <div class="partecipants-box children px-3 py-2"> -->
                          <label>Bambini (2-8 anni)</label>
                          <input type="number" pInputText class="w-full mt-1" [max]="
                                                checkMaxNumberOfKids(
                                                  p.id,
                                                  'children'
                                                )
                                              " [min]="0" formControlName="n_children" (input)="
                                                validatePackageInput(
                                                  $event,
                                                  p.id,
                                                  purchaseIndex,
                                                  'n_children'
                                                );
                                                updateMembersForPurchase(
                                                  p.id,
                                                  purchaseIndex
                                                )
                                              " />
                          @if (
                          sp.get("n_children")?.errors &&
                          sp.get("n_children")?.touched
                          ) {
                          <st-errors [errors]="
                                                  sp.get('n_children')?.errors
                                                "></st-errors>
                          }
                          <!-- </div> -->
                        </div>
                        <div class="col-4">
                          <label>Neonati (fino a 2 anni)</label>
                          <input type="number" pInputText class="w-full mt-1" [max]="
                                                checkMaxNumberOfKids(
                                                  p.id,
                                                  'infants'
                                                )
                                              " [min]="0" formControlName="n_infants" (input)="
                                                validatePackageInput(
                                                  $event,
                                                  p.id,
                                                  purchaseIndex,
                                                  'n_infants'
                                                );
                                                updateMembersForPurchase(
                                                  p.id,
                                                  purchaseIndex
                                                )
                                              " />
                          @if (
                          sp.get("n_infants")?.errors &&
                          sp.get("n_infants")?.touched
                          ) {
                          <st-errors [errors]="
                                                  sp.get('n_infants')?.errors
                                                "></st-errors>
                          }
                        </div>
                        }
                        <div class="col-12 mt-4 accordion-box" [ngClass]="
                                            maxMembersExceeded ? 'disabled' : ''
                                          ">
                          <p-accordion [activeIndex]="activeIndex">
                            @for (
                            m of getFrmMembersControlsForPckgsById(
                            p.id,
                            purchaseIndex
                            );
                            track m;
                            let mIndex = $index
                            ) {
                            <p-accordionTab>
                              <ng-template pTemplate="header">
                                <h4>
                                  Dati partecipante
                                  {{ mIndex + 1 }} -
                                  {{
                                  m.get("member_type")
                                  ?.value
                                  }}
                                </h4>
                              </ng-template>
                              <ng-template pTemplate="content">
                                <div class="grid" [formGroup]="m">
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Nome*</label>
                                      <input type="text" pInputText class="w-full mt-1" formControlName="name" />
                                      @if (
                                      m.get("name")
                                      ?.errors &&
                                      m.get("name")?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get('name')
                                                                ?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label> Cognome*</label>
                                      <input type="text" pInputText class="w-full mt-1" formControlName="last_name" />
                                      @if (
                                      m.get("last_name")
                                      ?.errors &&
                                      m.get("last_name")
                                      ?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get('last_name')
                                                                ?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>
                                        Data di
                                        nascita*</label>
                                      <p-calendar ngClass="w-full frm" [readonlyInput]="true" appendTo="body"
                                        panelStyleClass="custom-calendar" [touchUI]="false" [maxDate]="today"
                                        formControlName="date_of_birth" dateFormat="dd/mm/yy"
                                        [firstDayOfWeek]="1"></p-calendar>
                                      @if (
                                      m.get("date_of_birth")
                                      ?.errors &&
                                      m.get("date_of_birth")
                                      ?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'date_of_birth'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Genere*</label>
                                      <p-dropdown [options]="genders" optionValue="id" optionLabel="name"
                                        ngClass="w-full frm" placeholder="Scegli" formControlName="gender"></p-dropdown>
                                      @if (
                                      m.get("gender")
                                      ?.errors &&
                                      m.get("gender")?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get('gender')
                                                                ?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>
                                        Telefono*</label>
                                      <input type="text" pInputText class="w-full mt-1"
                                        formControlName="phone_number" />
                                      @if (
                                      m.get("phone_number")
                                      ?.errors &&
                                      m.get("phone_number")
                                      ?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'phone_number'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Email*</label>
                                      <input type="text" pInputText class="w-full mt-1"
                                        formControlName="email_address" />
                                      @if (
                                      m.get("email_address")
                                      ?.errors &&
                                      m.get("email_address")
                                      ?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'email_address'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Cittadinanza*</label>
                                      <input type="text" pInputText class="w-full mt-1" formControlName="nationality" />
                                      @if (
                                      m.get("nationality")
                                      ?.errors &&
                                      m.get("nationality")
                                      ?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'nationality'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Tipo di
                                        documento*</label>
                                      <p-dropdown [options]="id_type" optionValue="id" optionLabel="name"
                                        ngClass="w-full frm" placeholder="Scegli"
                                        formControlName="document_type"></p-dropdown>
                                      @if (
                                      m.get("document_type")
                                      ?.errors &&
                                      m.get("document_type")
                                      ?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'document_type'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Scadenza
                                        documento*</label>
                                      <p-calendar ngClass="w-full frm" [firstDayOfWeek]="1"
                                        formControlName="document_exp_date" [readonlyInput]="true" appendTo="body"
                                        [minDate]="today" panelStyleClass="custom-calendar" [touchUI]="false"
                                        dateFormat="dd/mm/yy"></p-calendar>
                                      @if (
                                      m.get(
                                      "document_exp_date"
                                      )?.errors &&
                                      m.get(
                                      "document_exp_date"
                                      )?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'document_exp_date'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Data emissione
                                        documento*</label>
                                      <p-calendar ngClass="w-full frm" [firstDayOfWeek]="1"
                                        formControlName="document_release_date" [readonlyInput]="true" appendTo="body"
                                        [maxDate]="today" panelStyleClass="custom-calendar" [touchUI]="false"
                                        dateFormat="dd/mm/yy"></p-calendar>
                                      @if (
                                      m.get(
                                      "document_release_date"
                                      )?.errors &&
                                      m.get(
                                      "document_release_date"
                                      )?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'document_release_date'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <label>Numero
                                        documento*</label>
                                      <input type="text" pInputText class="w-full mt-1"
                                        formControlName="document_number" />
                                      @if (
                                      m.get(
                                      "document_number"
                                      )?.errors &&
                                      m.get(
                                      "document_number"
                                      )?.dirty
                                      ) {
                                      <st-errors [errors]="
                                                              m.get(
                                                                'document_number'
                                                              )?.errors
                                                            "></st-errors>
                                      }
                                    </div>
                                  </div>
                                  <div class="col-12 md:col-4">
                                    <div class="mt-3">
                                      <div class="flex align-items-center gap-2 mt-6">
                                        <p-inputSwitch formControlName="disabled" inputId="disabled" />
                                        <label for="disabled" class="text-sm mb-1">Disabile</label>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex align-items-center gap-2 mt-6">
                                    <p-inputSwitch inputId="holder" formControlName="is_account_holder" (click)="
                                                          setAccountHolderPckgs(
                                                            pkgIndex,
                                                            purchaseIndex,
                                                            mIndex
                                                          )
                                                        " />
                                    <label for="holder" class="text-sm mb-1">
                                      Intestatario pratica
                                    </label>
                                  </div>
                                </div>
                              </ng-template>
                            </p-accordionTab>
                            }
                          </p-accordion>
                        </div>
                        @if (checkIfIsDblRoom(p.name)) {
                        <div class="mt-3">
                          <p-message severity="warn"
                            text="Acquistando questo pacchetto si verrà abbinati in camera con un altro viaggiatore. Per indicare una preferenza sul compagno di stanza, utilizzare il box note qui sotto."></p-message>
                        </div>
                        <div class="col-12">
                          <label>Note</label>
                          <textarea rows="5" pInputTextarea class="w-full mt-1" formControlName="notes"
                            placeholder="Es. preferenze sul compagno di stanza"></textarea>
                        </div>
                        }
                        <div class="col-12">
                          <label>Allergie</label>
                          <textarea rows="5" pInputTextarea class="w-full mt-1" formControlName="allergies"
                            placeholder="Allergie o intolleranze da segnalare"></textarea>
                        </div>
                      </div>
                    </form>
                    }
                    }
                    @if (overbooking) {
                    <div class="muted-r-bg alert-in-page w-full mt-4">
                      <div class="flex align-items-center flex-wrap gap-3">
                        <img src="/assets/media/icons/alert-g.png" width="40" />
                        <div class="flex flex-column gap-1">
                          <strong class="text-base">Attenzione</strong>
                          <small>Hai raggiunto il numero massimo di
                            prenotazioni!</small>
                        </div>
                      </div>
                    </div>
                    }

                    <!-- [disabled]="!canAddPackage(p.id)" -->

                    <div class="flex out-green justify-content-center md:justify-content-end mt-4">
                      <p-button (click)="selectPackage(p.id)" label="Aggiungi" size="small" styleClass="px-6"
                        [outlined]="true"></p-button>
                    </div>
                  </ng-template>
                </p-accordionTab>
              </p-accordion>
            </div>
            }
            }
            @if (travel.addl_services.length > 0) {
            <!--SERVIZI AGGIUNTIVI-->
            <div class="form-section mb-4">
              <strong class="yellow">Servizi aggiuntivi:</strong>
              @for (s of travel.addl_services; track $index) {
              <div class="flex flex-column md:flex-row md:justify-content-between">
                <div class="flex flex-column md:flex-row align-items-center md:gap-2">
                  <h3>{{ s.title |titlecase }}</h3>
                  <h2 class="green">
                    {{
                    s.price
                    | currency
                    : travel.currency
                    : "symbol"
                    : ".2-2"
                    }}
                  </h2>
                  @if (getaddlServiceMembersTotal($index) > 0) {
                  <small class="md:mt-2 green">Acquistato x{{
                    getaddlServiceMembersTotal($index)
                    }}</small>
                  }
                </div>
                <div class="buttons-set out-green flex align-items-center gap-2">
                  @if (frmAddlService.length > 0) {
                  <p-button [outlined]="true" icon="pi pi-minus" [rounded]="true"
                    (click)="decreasePeople($index)"></p-button>
                  }
                  <p-button [outlined]="true" icon="pi pi-plus" [rounded]="true"
                    (click)="increasePeople($index)"></p-button>
                </div>
              </div>
              <small class="grey-text">{{ s.description | titlecase}}</small>

              }
            </div>
            }
            <!-- @if (travel.addl_insurances!.length > 0) { -->
            @if ((travel.addl_insurances?.length ?? 0) > 0) {
            <!--assicurazione-->
            <div class="form-section mb-4">
              <strong class="yellow">Assicurazioni:</strong>
              @for (s of travel.addl_insurances; track $index) {
              <div class="flex flex-column md:flex-row md:justify-content-between">
                <div class="flex flex-column md:flex-row align-items-center md:gap-2">

                  <h3>{{ s.title |titlecase}}</h3>
                  <h2 class="green">
                    {{
                    s.price
                    | currency
                    : travel.currency
                    : "symbol"
                    : ".2-2"
                    }}
                  </h2>
                  @if (getaddlInsurancesMembersTotal($index) > 0) {
                  <small class="md:mt-2 green">Acquistato x{{
                    getaddlInsurancesMembersTotal($index)
                    }}</small>
                  }
                </div>
                <div class="buttons-set out-green flex align-items-center gap-2">
                  @if (frmInsurances.length > 0) {
                  <p-button [outlined]="true" icon="pi pi-minus" [rounded]="true"
                    (click)="decreasePeopleInsurances($index)"></p-button>
                  }
                  <p-button [outlined]="true" icon="pi pi-plus" [rounded]="true"
                    (click)="increasePeopleInsurances($index)"></p-button>
                </div>
              </div>
              <small class="grey-text">{{ s.description }}</small>
              <hr class="mt-5">
              }
            </div>
            }
          </div>

          <div class="col-12 md:col-12 lg:col-4 mb-4">
            <div class="card-dep-container">
              <div class="travel-card card-dep">
                <div class="bg-travel" [ngStyle]="{
                            'background-image':
                              'url(' +
                              (travel
                                | travelImagePipe
                                | imagePipe: 'travel' : 'lg') +
                              ')',
                          }">
                  <div class="gradient"></div>
                  <div class="lonely-title">
                    <h3 class="m-0">
                      {{ travel.from_date | date: "dd MMMM yyyy" }} -
                      {{ travel.to_date | date: "dd MMMM yyyy" }}
                    </h3>
                  </div>
                </div>

                <div class="p-4">


                  <div class="section-card pt-0">
                    <!-- ACCONTO + SALDO -->
                    @if (checkout_type === "advance") {
                    @let acconto =
                    travel.checkout_advance! *
                    fullPaymentPkgs.tot_participants!;
                    @let accontoIns = acconto + addlInsurancesTotal;
                    @if(addlInsurancesTotal===0){
                    <small class="grey-text">Totale acconto
                      {{
                      acconto
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }}
                      @if (
                      fullPaymentPkgs.fullTotal > 0 &&
                      travel.customer_pays_fees
                      ) {
                      (di cui Costi di servizio
                      {{
                      acconto * 0.03
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }})
                      }
                    </small>}@else {

                    <small class="grey-text">Totale acconto
                      {{
                      accontoIns
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }}
                      @if (
                      fullPaymentPkgs.fullTotal > 0 &&
                      travel.customer_pays_fees
                      ) {
                      (di cui Costi di servizio
                      {{
                      accontoIns * 0.03
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }})
                      }
                    </small>
                    }
                    <h2 class="green m-0">
                      <i class="pi pi-shopping-cart mr-2" style="font-size: 1.2rem"></i>
                      {{
                      fullPaymentPkgs.fullTotal + addlServiceTotal + addlInsurancesTotal
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }}
                    </h2>
                    <small class="grey-text">
                      @let saldo = fullPaymentPkgs.fullTotal
                      - acconto
                      - addlServiceTotal
                      - addlInsurancesTotal;

                      Saldo:
                      {{ saldo | currency : travel.currency : 'symbol' : '.2-2' }}
                      <!-- Saldo:
                      {{
                      fullPaymentPkgs.fullTotal -
                      acconto +
                      addlServiceTotal
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }} -->
                      <!-- @if (
                      fullPaymentPkgs.fullTotal > 0 &&
                      travel.customer_pays_fees
                      ) {
                      (di cui Costi di servizio
                      {{
                      (fullPaymentPkgs.fullTotal -
                      acconto +
                      addlServiceTotal) *
                      0.03
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }})
                      }
                    </small>
                    } -->
                      @if (
                      fullPaymentPkgs.fullTotal > 0 &&
                      travel.customer_pays_fees
                      ) {
                      (di cui Costi di servizio
                      {{
                      saldo *
                      0.03
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }})
                      }
                    </small>
                    }
                    <!-- INTERO IMPORTO -->
                    @else {
                    <small class="grey-text">Totale</small>
                    @if (previousBookingsTotal > 0) {
                    <small class="grey-text block"><b>Importo versato: </b>
                      <span class="yellow">{{ previousBookingsTotal | currency : travel.currency : 'symbol' : '.2-2'
                        }}</span></small>
                    }
                    <h2 class="green m-0">
                      <i class="pi pi-shopping-cart mr-2" style="font-size: 1.2rem"></i>
                      {{
                      totalToPay
                      | currency
                      : travel.currency
                      : "symbol"
                      : ".2-2"
                      }}
                    </h2>
                    @if (fullPaymentPkgs.fullTotal > 0 && totalAfterPrevious < 0) { <div
                      class="muted-r-bg alert-in-page mb-3">
                      <small class="font-medium">Il sistema procederà alla generazione di un rimborso di
                        {{ totalAfterPrevious * -1 | currency : travel.currency : 'symbol' : '.2-2' }}</small>
                  </div>
                  }
                  @if (
                  fullPaymentPkgs.fullTotal > 0 &&
                  travel.customer_pays_fees
                  ) {
                  <small class="grey-text">
                    (di cui Costi di servizio
                    {{
                    totalToPay *
                    0.03
                    | currency
                    : travel.currency
                    : "symbol"
                    : ".2-2"
                    }})
                  </small>
                  }
                  }
                </div>

                @if (frmJoin.get("with_flights")?.value === true) {
                <div class="section-card flex align-items-center gap-3">
                  <img src="assets/media/icons/airplane-ticket-60.png" height="24" />
                  <span>Volo incluso</span>
                </div>
                } @else {
                <div class="section-card flex align-items-center gap-3">
                  <img src="assets/media/icons/airplane-ticket-60.png" height="24" />
                  <span>Volo non incluso</span>
                </div>
                }
                @if (travel.pricing_mode != 2) {
                <div class="section-card">
                  <div class="flex flex-column gap-1">
                    <div class="flex align-items-center gap-3">
                      <img src="assets/media/icons/double-bed.png" height="24" />
                      <div class="flex flex-column">
                        <b>Totale camere</b>
                        <span>{{
                          fullPaymentLegacy.fullTotal -
                          fullPaymentLegacy.advanceTotal
                          | currency
                          : travel.currency
                          : "symbol"
                          : ".2-2"
                          }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                }
                <div class="section-card">
                  <div class="flex flex-column gap-1">
                    <div class="flex align-items-center gap-3">
                      <img src="assets/media/icons/clipboard-60.png" height="24" />
                      <div class="flex flex-column">
                        <b>Documenti</b>
                        <div class="flex flex-column gap-1" [ngClass]="{ 'mt-2': luggage_attachment }">
                          <a (click)="insuranceTextDialog = true" class="link-o">Termini e condizioni</a>
                          @if (luggage_attachment) {
                          <a [href]="
                                          environmentMediaUrl +
                                          '/' +
                                          luggage_attachment.path
                                        " class="link-o">Assicurazione medico bagaglio</a>
                          }
                          @if (cancellation_attachment) {
                          <a [href]="
                                          environmentMediaUrl +
                                          '/' +
                                          cancellation_attachment.path
                                        " class="link-o">Assicurazione annullamento</a>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                @if (frmAddlService.length > 0) {
                <div class="pad-card flex align-items-center gap-3">
                  <div class="flex flex-column gap-1">
                    <div class="flex align-items-center gap-3">
                      <img src="assets/media/icons/extra.png" height="24" />
                      <div class="flex flex-column gap-1">
                        <b>Servizi aggiuntivi</b>
                        @if (addlServiceTotal === 0) {
                        <small class="grey-text">Nessun servizio aggiuntivo
                          acquistato</small>
                        } @else {
                        <span>{{
                          addlServiceTotal
                          | currency
                          : travel.currency
                          : "symbol"
                          : ".2-2"
                          }}</span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  <div class="flex align-items-center justify-content-center">
    <div [ngClass]="{
                    cursorNotAllowed:
                      overbooking ||
                      frmRooms.invalid ||
                      maxMembersExceeded ||
                      (travel.pricing_mode === 2 && isPaymentDisabled),
                  }">
      @if (
      travel.pricing_mode === 2 &&
      frmSelectedPackages.value.length === 0
      ) {
      <div class="flex flex-column align-items-center">
        <p-button label="Il tuo carrello è vuoto" size="small" styleClass="slide px-6" [disabled]="true"></p-button>
        <span class="yellow mt-2 text-xs">*Seleziona uno o più pacchetti per proseguire</span>
      </div>
      } @else {
      <div class="flex flex-column align-items-center">
        <p-button [label]="travel.gmg_finalized_on ? 'Conferma prenotazione' : 'Vai al pagamento'" size="small"
          styleClass="slide px-6 " (click)="goTo(1)" [disabled]="
                          overbooking ||
                          frmRooms.invalid ||
                          maxMembersExceeded ||
                          (travel.pricing_mode === 2 && isPaymentDisabled)
                        "></p-button>
        @if (
        overbooking ||
        frmRooms.invalid ||
        maxMembersExceeded ||
        (travel.pricing_mode === 2 && isPaymentDisabled)
        ) {
        <span class="yellow mt-2 text-xs">*Compila correttamente tutti i dati richiesti</span>
        }
      </div>
      }
    </div>
  </div>
  }
  @case (1) {
  <div class="mt-4">
    <div class="flex flex-column md:flex-row align-items-center md:justify-content-between">
      <div>
        @if (travel.gmg_finalized_on) {
        <h2>Conferma prenotazione</h2>
        } @else {
        <h2>Pagamento</h2>
        }
        <small class="grey-text">Numero pratica #{{ travel.internal_code }}</small>
      </div>

      <div class="clickable block flex align-items-center gap-1 mb-3 mt-3 md:mt-0" (click)="goTo(0)">
        <i class="pi pi-chevron-left text-xs"></i>
        <small>Torna ai dati della prenotazione</small>
      </div>
    </div>
    <div class="mt-5 form-section mb-4">
      <strong>Dati dell'intestatario pratica</strong>
      <div class="grid mt-3">
        <div class="col-12 md:col-4">
          <label>Nome*</label>
          <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_name" />
          @if (
          frmJoin.get("accountholder_name")?.errors &&
          frmJoin.get("accountholder_name")?.touched
          ) {
          <st-errors [errors]="frmJoin.get('accountholder_name')?.errors"></st-errors>
          }
        </div>
        <div class="col-12 md:col-4">
          <label>Cognome*</label>
          <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_last_name" />
          @if (
          frmJoin.get("accountholder_last_name")?.errors &&
          frmJoin.get("accountholder_last_name")?.touched
          ) {
          <st-errors [errors]="
                            frmJoin.get('accountholder_last_name')?.errors
                          "></st-errors>
          }
        </div>
        <div class="col-12 md:col-4">
          <label>Codice fiscale*</label>
          <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_fiscal_code" />
          @if (
          frmJoin.get("accountholder_fiscal_code")?.errors &&
          frmJoin.get("accountholder_fiscal_code")?.dirty
          ) {
          <st-errors [errors]="
                            frmJoin.get('accountholder_fiscal_code')?.errors
                          "></st-errors>
          }
        </div>
        <div class="col-12 md:col-4">
          <label>Nazione di nascita*</label>
          <div class="mt-1">
            <p-autoComplete [forceSelection]="true" [suggestions]="suggestedCountries"
              (completeMethod)="filterCountries($event)" field="name" dataKey="ISO" class="frm mt-1"
              [emptyMessage]="'Nessun risultato trovato'" emptyFilterMessage="Nessun risultato trovato"
              formControlName="accountholder_country_iso">
            </p-autoComplete>
            @if (
            frmJoin.get("accountholder_country_iso")?.errors &&
            frmJoin.get("accountholder_country_iso")?.touched
            ) {
            <st-errors [errors]="
                              frmJoin.get('accountholder_country_iso')?.errors
                            "></st-errors>
            }
          </div>
        </div>
        <div class="col-12 md:col-4">
          <label>Indirizzo*</label>
          <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_address" />
          @if (
          frmJoin.get("accountholder_address")?.errors &&
          frmJoin.get("accountholder_address")?.touched
          ) {
          <st-errors [errors]="
                            frmJoin.get('accountholder_address')?.errors
                          "></st-errors>
          }
        </div>
        <div class="col-12 md:col-4">
          <label>CAP*</label>
          <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_zip_code" />
          @if (
          frmJoin.get("accountholder_zip_code")?.errors &&
          frmJoin.get("accountholder_zip_code")?.touched
          ) {
          <st-errors [errors]="
                            frmJoin.get('accountholder_zip_code')?.errors
                          "></st-errors>
          }
        </div>
        <div class="col-12 md:col-4">
          <label>Città*</label>
          <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_city" />
          @if (
          frmJoin.get("accountholder_city")?.errors &&
          frmJoin.get("accountholder_city")?.touched
          ) {
          <st-errors [errors]="frmJoin.get('accountholder_cityv')?.errors"></st-errors>
          }
        </div>
        <div class="col-12 md:col-4">
          <label>Provincia*</label>
          <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_province" />
          @if (
          frmJoin.get("accountholder_province")?.errors &&
          frmJoin.get("accountholder_province")?.touched
          ) {
          <st-errors [errors]="
                            frmJoin.get('accountholder_provincev')?.errors
                          "></st-errors>
          }
        </div>
        <div class="col-12 md:col-4">
          <label>Telefono*</label>
          <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_mobile_phone" />
          @if (
          frmJoin.get("accountholder_mobile_phone")?.errors &&
          frmJoin.get("accountholder_mobile_phone")?.touched
          ) {
          <st-errors [errors]="
                            frmJoin.get('accountholder_mobile_phone')?.errors
                          "></st-errors>
          }
        </div>
        <div class="col-12 md:col-6">
          <label>Email*</label>
          <input type="text" pInputText class="w-full mt-1" formControlName="accountholder_email" />
          @if (
          frmJoin.get("accountholder_email")?.errors &&
          frmJoin.get("accountholder_email")?.touched
          ) {
          <st-errors [errors]="frmJoin.get('accountholder_email')?.errors"></st-errors>
          }
        </div>
        <div class="col-12 md:col-6">
          <label [ngClass]="
                          frmJoin.get('confirm_email')?.enabled
                            ? ''
                            : 'disabled'
                        ">Conferma email*</label>
          <input type="text" pInputText class="w-full mt-1" formControlName="confirm_email" />
          @if (
          frmJoin.get("confirm_email")?.enabled &&
          frmJoin.get("accountholder_email")?.value !==
          frmJoin.get("confirm_email")?.value
          ) {
          <div>
            <small class="form-danger">Le email non coincidono</small>
          </div>
          }
        </div>
      </div>
    </div>

    @let tp = frmJoin.get("third_party_booking")!.value;

    <div class="mt-5 form-section mb-4">
      <div class="grid">
        <!--CASO ANTICIPO + SALDO-->
        @if (checkout_type === "advance") {
        <!-- NOT THIRD PARTY -->
        @if (!tp) {
        <div class="col-12 flex flex-column gap-2">
          <strong>Acconto</strong>
          <small class="grey-text">Paga in sicurezza con Stripe: utilizza la tua carta
            di credito o debito, oppure effettua un bonifico
            SEPA con la garanzia di una protezione avanzata dei
            tuoi dati. Prenota il tuo viaggio senza
            preoccupazioni!</small>
          <!-- <div class="flex align-items-center gap-1">
                <small class="grey-text">Totale:</small>
                <h3 class="yellow m-0">
                  {{
                  fullPaymentPkgs.advanceTotal
                  | currency
                  : travel.currency
                  : "symbol"
                  : ".2-2"
                  }}
                </h3>
              </div>
              @if (
              fullPaymentPkgs.fullTotal > 0 &&
              travel.customer_pays_fees
              ) {
              <small class="grey-text">
                (di cui Costi di servizio
                {{
                travel.checkout_advance! *
                fullPaymentPkgs.tot_participants! *
                0.03
                | currency
                : travel.currency
                : "symbol"
                : ".2-2"
                }})
              </small>
              } -->
          <div class="flex align-items-center gap-1">

            @let acconto =
            travel.checkout_advance! *
            fullPaymentPkgs.tot_participants!;
            @let accontoIns = acconto + addlInsurancesTotal;
            @if(addlInsurancesTotal===0){
            <small class="grey-text">Totale acconto
              <h3 class="yellow m-0">
                {{
                acconto
                | currency
                : travel.currency
                : "symbol"
                : ".2-2"
                }}</h3>
              @if (
              fullPaymentPkgs.fullTotal > 0 &&
              travel.customer_pays_fees
              ) {
              (di cui Costi di servizio
              {{
              acconto * 0.03
              | currency
              : travel.currency
              : "symbol"
              : ".2-2"
              }})
              }
            </small>}@else {

            <small class="grey-text">Totale acconto
              <h3 class="yellow m-0">
                {{
                accontoIns
                | currency
                : travel.currency
                : "symbol"
                : ".2-2"
                }}</h3>
              @if (
              fullPaymentPkgs.fullTotal > 0 &&
              travel.customer_pays_fees
              ) {
              (di cui Costi di servizio
              {{
              accontoIns * 0.03
              | currency
              : travel.currency
              : "symbol"
              : ".2-2"
              }})
              }
            </small>
            }





          </div>
          <div class="flex align-items-center gap-2 mt-2">
            <p-checkbox [binary]="true" [formControl]="tcAccept" inputId="acceptTc" />
            <div>
              <label for="acceptTc">Accetto </label>
              <span class="link-inline font-12" (click)="
                                  $event.stopImmediatePropagation(); openTc()
                                ">Termini e Condizioni</span>
            </div>
          </div>
        </div>
        }
        <!-- THIRD PARTY -->
        @else {
        <div class="col-12 flex flex-column gap-2">
          <strong>Acconto</strong>
          <small class="grey-text">Scegli se il viaggiatore verserà l'acconto tramite
            bonifico o contanti. Entrambe le transazioni saranno
            monitorabili nella pagina di gestione del viaggio.
            In caso di bonifico, invieremo una mail con le
            coordinate bancarie.</small>
          <!-- <div class="flex align-items-center gap-1">
                <small class="grey-text">Totale:</small>
                <h3 class="yellow m-0">
                  {{
                  fullPaymentPkgs.advanceTotal
                  | currency
                  : travel.currency
                  : "symbol"
                  : ".2-2"
                  }}
                </h3>
              </div>
              @if (
              fullPaymentPkgs.fullTotal > 0 &&
              travel.customer_pays_fees
              ) {
              <small class="grey-text">
                (di cui Costi di servizio
                {{
                travel.checkout_advance! *
                fullPaymentPkgs.tot_participants! *
                0.03
                | currency
                : travel.currency
                : "symbol"
                : ".2-2"
                }})
              </small>
              } -->
          @let acconto =
          travel.checkout_advance! *
          fullPaymentPkgs.tot_participants!;
          @let accontoIns = acconto + addlInsurancesTotal;
          @if(addlInsurancesTotal===0){
          <small class="grey-text">Totale acconto
            <h3 class="yellow m-0">
              {{
              acconto
              | currency
              : travel.currency
              : "symbol"
              : ".2-2"
              }}</h3>
            @if (
            fullPaymentPkgs.fullTotal > 0 &&
            travel.customer_pays_fees
            ) {
            (di cui Costi di servizio
            {{
            acconto * 0.03
            | currency
            : travel.currency
            : "symbol"
            : ".2-2"
            }})
            }
          </small>}@else {

          <small class="grey-text">Totale acconto
            <h3 class="yellow m-0">
              {{
              accontoIns
              | currency
              : travel.currency
              : "symbol"
              : ".2-2"
              }}</h3>
            @if (
            fullPaymentPkgs.fullTotal > 0 &&
            travel.customer_pays_fees
            ) {
            (di cui Costi di servizio
            {{
            accontoIns * 0.03
            | currency
            : travel.currency
            : "symbol"
            : ".2-2"
            }})
            }
          </small>
          }
        </div>
        <!-- PULSANTI SCELTA METODO DI PAGAMENTO -->
        <!-- cash adv -->
        <div class="col-12">
          <div class="method flex align-items-center justify-content-center gap-3 p-2"
            (click)="paymentMethod(enumPaymentMethod.CASH_ADV)" [ngClass]="
                              frmJoin.get('payment_method')?.value ===
                              enumPaymentMethod.CASH_ADV
                                ? 'chosen-method'
                                : ''
                            ">
            <img src="/assets/media/icons/money-flow.png" height="50" />
            <div>
              <strong>Contanti</strong>
            </div>
          </div>
        </div>
        <!-- bank adv -->
        <div class="col-12">
          <div class="method flex align-items-center justify-content-center gap-3 p-2" (click)="
                              paymentMethod(enumPaymentMethod.BANK_TRANSFER_ADV)
                            " [ngClass]="
                              frmJoin.get('payment_method')?.value ===
                              enumPaymentMethod.BANK_TRANSFER_ADV
                                ? 'chosen-method'
                                : ''
                            ">
            <img src="/assets/media/icons/credit-cards-payment.png" height="50" />
            <div>
              <strong>Bonifico bancario</strong>
            </div>
          </div>
        </div>
        @if (
        frmJoin.get("payment_method")?.value ===
        enumPaymentMethod.CASH_ADV
        ) {
        <div class="col-12 md:col-4">
          <div class="flex align-items-center gap-2 mt-6">
            <label for="tp_payed"> Segna come pagato </label>
            <p-inputSwitch inputId="tp_payed" [formControl]="payed" />
          </div>
        </div>
        }
        }
        }
        <!-- CASO SALDO COMPLETO -->
        @else {
        <!-- NOT THIRD PARTY -->
        @if (!tp) {
        <div class="col-12 flex flex-column gap-2">
          <strong>Saldo</strong>
          <small class="grey-text">Paga in sicurezza con <b>Stripe</b> utilizza la tua
            <b>carta di credito o debito</b>, oppure effettua un
            <b>bonifico SEPA</b> con la garanzia di una
            protezione avanzata dei tuoi dati. Prenota il tuo
            viaggio senza preoccupazioni!</small>
          @if (previousBookingsTotal > 0) {
          <small class="grey-text block"><b>Importo versato: </b>
            <span class="yellow">{{ previousBookingsTotal | currency : travel.currency : 'symbol' : '.2-2'
              }}</span></small>
          }
          <div class="flex align-items-center gap-1">
            <small class="grey-text">Totale:</small>
            <!-- <h3 class="yellow m-0">
                  {{
                  fullPaymentPkgs.fullTotal + addlServiceTotal
                  | currency
                  : travel.currency
                  : "symbol"
                  : ".2-2"
                  }}
                </h3>
              </div>
              @if (travel.customer_pays_fees) {
              <small class="grey-text">
                (di cui Costi di servizio
                {{
                (fullPaymentPkgs.fullTotal + addlServiceTotal) *
                0.03
                | currency
                : travel.currency
                : "symbol"
                : ".2-2"
                }})
              </small>
              } -->
            <h3 class="yellow m-0">
              {{
              totalToPay
              | currency
              : travel.currency
              : "symbol"
              : ".2-2"
              }}
            </h3>
          </div>
          @if (fullPaymentPkgs.fullTotal > 0 && totalAfterPrevious < 0) { <div class="muted-r-bg alert-in-page mb-3">
            <small class="font-medium">Il sistema procederà alla generazione di un rimborso di
              {{ totalAfterPrevious * -1 | currency : travel.currency : 'symbol' : '.2-2' }}</small>
        </div>
        }
        @if (travel.customer_pays_fees) {
        <small class="grey-text">
          (di cui Costi di servizio
          {{
          totalToPay *
          0.03
          | currency
          : travel.currency
          : "symbol"
          : ".2-2"
          }})
        </small>
        }
      </div>
      <div class="flex align-items-center gap-2 mt-2">
        <p-checkbox [binary]="true" [formControl]="tcAccept" inputId="acceptTc"></p-checkbox>

        <div>
          <label for="acceptTc">Accetto </label>
          <span class="link-inline font-12" (click)="
                                $event.stopImmediatePropagation(); openTc()
                              ">Termini e Condizioni</span>
        </div>
      </div>
      }
      <!-- THIRD PARTY -->
      @else {
      <div class="col-12 flex flex-column gap-2">
        <strong>Saldo</strong>
        <small class="grey-text">Scegli se il viaggiatore verserà l'importo tramite
          bonifico o contanti. Entrambe le transazioni saranno
          monitorabili nella pagina di gestione del viaggio.
          In caso di bonifico, invieremo una mail con le
          coordinate bancarie.</small>
        <div class="flex align-items-center gap-1">
          <small class="grey-text">Totale:</small>
          <!-- <h3 class="yellow m-0">
                  {{
                  fullPaymentPkgs.fullTotal + addlServiceTotal
                  | currency
                  : travel.currency
                  : "symbol"
                  : ".2-2"
                  }}
                </h3>
              </div>

              @if (travel.customer_pays_fees) {
              <small class="grey-text">
                (di cui Costi di servizio
                {{
                (fullPaymentPkgs.fullTotal + addlServiceTotal) *
                0.03
                | currency
                : travel.currency
                : "symbol"
                : ".2-2"
                }})
              </small>
              } -->
          <h3 class="yellow m-0">
            {{
            fullPaymentPkgs.fullTotal + addlServiceTotal+ addlInsurancesTotal
            | currency
            : travel.currency
            : "symbol"
            : ".2-2"
            }}
          </h3>
        </div>

        @if (travel.customer_pays_fees) {
        <small class="grey-text">
          (di cui Costi di servizio
          {{
          (fullPaymentPkgs.fullTotal + addlServiceTotal + addlInsurancesTotal) *
          0.03
          | currency
          : travel.currency
          : "symbol"
          : ".2-2"
          }})
        </small>
        }
      </div>
      <!-- PULSANTI SCELTA METODO DI PAGAMENTO -->
      <!-- cash payoff -->
      <div class="col-12">
        <div class="method flex align-items-center justify-content-center gap-3 p-2" (click)="
                              paymentMethod(enumPaymentMethod.CASH_PAYOFF)
                            " [ngClass]="
                              frmJoin.get('payment_method')?.value ===
                              enumPaymentMethod.CASH_PAYOFF
                                ? 'chosen-method'
                                : ''
                            ">
          <img src="/assets/media/icons/money-flow.png" height="50" />
          <div>
            <strong>Contanti</strong>
          </div>
        </div>
      </div>
      <!-- bank payoff -->
      <div class="col-12">
        <div class="method flex align-items-center justify-content-center gap-3 p-2" (click)="
                              paymentMethod(
                                enumPaymentMethod.BANK_TRANSFER_PAYOFF
                              )
                            " [ngClass]="
                              frmJoin.get('payment_method')?.value ===
                              enumPaymentMethod.BANK_TRANSFER_PAYOFF
                                ? 'chosen-method'
                                : ''
                            ">
          <img src="/assets/media/icons/credit-cards-payment.png" height="50" />
          <div>
            <strong>Bonifico bancario</strong>
          </div>
        </div>
      </div>
      @if (
      frmJoin.get("payment_method")?.value ===
      enumPaymentMethod.CASH_PAYOFF
      ) {
      <div class="col-12 md:col-4">
        <div class="flex align-items-center gap-2 mt-6">
          <label for="tp_payed"> Segna come pagato </label>
          <p-inputSwitch inputId="tp_payed" [formControl]="payed" />
        </div>
      </div>
      }
      }
      }
    </div>
  </div>
</div>

<div class="flex align-items-center justify-content-center m-6">
  <div [ngClass]="{
                    cursorNotAllowed: frmJoin.invalid,
                  }">
    <p-button styleClass="w-full slide"
      [label]="tp ? 'Registra' : previousBookings.length > 0 ? 'Completa la prenotazione' : 'Paga'"
      [disabled]="frmJoin.invalid || !tcAccept.value" (click)="submit()" [loading]="loading"></p-button>
  </div>
</div>
}
}
</form>
</div>
</div>
}
}
<p-dialog [closable]="true" header="Termini e Condizioni" [modal]="true" [(visible)]="visible"
  [style]="{ width: '50rem' }" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">
  <ng-template pTemplate="body">
    <div class="text">
      <section class="terms">
        <h3>Condizioni Generali Contratto di Pacchetto Turistico</h3>
        <p>
          Costituiscono parte integrante del contratto di viaggio, oltre che le condizioni generali che seguono,
          la descrizione del pacchetto turistico contenuta nel catalogo, ovvero nel separato programma di viaggio,
          nonché la conferma di prenotazione dei servizi richiesti dal viaggiatore unitamente ai documenti di cui
          all'art. 36 comma 8 del Codice del Turismo. Quando il contratto è intermediato da una Agenzia di viaggio
          la conferma della prenotazione viene inviata dal Tour Operator all'Agenzia di Viaggi, quale mandataria
          del Viaggiatore e quest'ultimo avrà diritto di riceverla dalla medesima. Nel sottoscrivere la proposta di
          compravendita di pacchetto turistico, il Viaggiatore dichiara espressamente di aver compreso ed
          accettato, per sé e per i soggetti per i quali chiede il servizio tutto compreso, sia il contratto di
          viaggio per come ivi disciplinato, sia le avvertenze in essa contenute, sia le presenti condizioni
          generali.
        </p>

        <h3>1. Fonti Normative</h3>
        <p>
          La vendita di pacchetti turistici, che abbiano ad oggetto servizi da fornire in territorio sia
          nazionale sia internazionale, è disciplinata dagli artt. 32-51 novies del D. Lgs. n. 79 del 23 maggio
          2011 (cd. "Codice del Turismo", in seguito CdT), come attualmente modificato dal D.Lgs. n. 62 del
          06.06.2018 di attuazione della Direttiva UE n. 2015/2302, nonché dalle disposizioni del Codice Civile in
          tema di trasporto, appalto di servizi e mandato, in quanto applicabili, e dal Codice della Navigazione
          (R.D. n. 327 del 30.03.1942).
        </p>

        <h3>2. Regime Amministrativo</h3>
        <p>
          L'organizzatore e l'Agenzia venditrice del pacchetto turistico, cui il viaggiatore si rivolge, devono
          essere abilitati all'esecuzione delle rispettive attività in base alla legislazione vigente.
          L'Organizzatore e il venditore rendono noti ai terzi, prima della conclusione del contratto, gli estremi
          della polizza assicurativa per la copertura dei rischi derivanti da responsabilità civile
          professionale, nonché gli estremi della garanzia contro i rischi di insolvenza o fallimento
          dell'organizzatore e del venditore, ciascuno per quanto di propria competenza, ai fini della
          restituzione delle somme versate o del rientro del viaggiatore presso la località di partenza.
        </p>

        <h3>3. Definizioni (Art. 33 CdT)</h3>
        <p>Ai fini del presente contratto s'intende per:</p>
        <ol type="a">
          <li><strong>Viaggiatore:</strong> chiunque intenda concludere o stipulare un contratto o sia autorizzato a
            viaggiare in base a un contratto di turismo organizzato;</li>
          <li><strong>Professionista:</strong> qualsiasi persona fisica o giuridica pubblica o privata che, nell'ambito
            della sua attività commerciale, industriale, artigianale o professionale agisca, nei contratti di turismo
            organizzato, anche tramite altra persona che operi in suo nome o per suo conto, in veste di organizzatore,
            venditore, professionista che agevola servizi turistici collegati o di fornitore di servizi turistici, ai
            sensi della normativa vigente;</li>
          <li><strong>Organizzatore:</strong> il professionista che combini pacchetti e li venda o li offra in vendita
            direttamente o tramite o unitamente a un altro professionista;</li>
          <li><strong>Venditore:</strong> il professionista diverso dall'Organizzatore che venda o offra in vendita
            pacchetti combinati da un organizzatore.</li>
        </ol>

        <h3>4. Nozione di Pacchetto Turistico (Art. 33, comma 1, n. 4, lett. c) CdT)</h3>
        <p>
          Per pacchetto turistico si intende la "combinazione di almeno due tipi diversi di servizi turistici ai
          fini dello stesso viaggio o della stessa vacanza, se si verifica almeno una delle seguenti condizioni:
        </p>
        <ol>
          <li>
            che tali servizi siano combinati da un unico professionista, anche su richiesta del viaggiatore o
            conformemente a una sua selezione, prima che sia concluso un contratto unico per tutti i servizi;
          </li>
          <li>
            tali servizi, anche se conclusi con contratti distinti con singoli fornitori di servizi turistici,
            siano:
            <ol>
              <li>acquistati presso un unico punto vendita e selezionati prima che il viaggiatore acconsenta al
                pagamento;</li>
              <li>offerti, venduti o fatturati a un prezzo forfettario o globale;</li>
              <li>pubblicizzati o venduti sotto la denominazione "pacchetto" o denominazione analoga;</li>
              <li>
                combinati dopo la conclusione di un contratto con cui il professionista consente al viaggiatore
                di scegliere tra una selezione di tipi diversi di servizi turistici, oppure acquistati presso
                professionisti distinti attraverso processi collegati di prenotazione per via telematica ove il
                nome del viaggiatore, gli estremi del pagamento e l'indirizzo di posta elettronica siano
                trasmessi dal professionista con cui sia concluso il primo contratto a uno o più professionisti e
                il contratto con quest'ultimo o questi ultimi professionisti sia concluso al più tardi 24 ore dopo
                la conferma della prenotazione del primo servizio turistico.
              </li>
            </ol>
          </li>
        </ol>

        <h3>5. Informazioni Precontrattuali al Viaggiatore (Art. 34 CdT)</h3>
        <p>
          Prima della conclusione del contratto di pacchetto turistico o di un'offerta corrispondente,
          l'organizzatore e, nel caso in cui il pacchetto sia venduto tramite un venditore, anche quest'ultimo,
          forniscono al viaggiatore il pertinente modulo informativo standard di cui all'allegato A, parte I o
          parte II del CdT, nonché le seguenti informazioni:
        </p>
        <ol type="a">
          <li>
            le caratteristiche principali dei servizi turistici, quali:
            <ol>
              <li>la destinazione o le destinazioni del viaggio, l'itinerario e i periodi di soggiorno con relative date
                e, se è incluso l'alloggio, il numero di notti comprese;</li>
              <li>i mezzi, le caratteristiche e le categorie di trasporto, i luoghi, le date e gli orari di partenza e
                ritorno, la durata e la località di sosta intermedia e le coincidenze; nel caso in cui l'orario esatto
                non sia ancora stabilito, l'organizzatore e, se del caso, il venditore, informano il viaggiatore
                dell'orario approssimativo di partenza e ritorno;</li>
              <li>l'ubicazione, le caratteristiche principali e, ove prevista, la categoria turistica dell'alloggio ai
                sensi della regolamentazione del paese di destinazione;</li>
              <li>i pasti forniti;</li>
              <li>le visite, le escursioni o altri servizi inclusi nel prezzo totale pattuito del pacchetto;</li>
              <li>i servizi turistici prestati al viaggiatore in quanto membro di un gruppo e, in tal caso, le
                dimensioni approssimative del gruppo;</li>
              <li>la lingua in cui sono prestati i servizi;</li>
              <li>se il viaggio o la vacanza sono idonei a persone a mobilità ridotta e, su richiesta del viaggiatore,
                informazioni precise sull'idoneità del viaggio o della vacanza che tenga conto delle esigenze del
                viaggiatore;</li>
            </ol>
          </li>
          <li>la denominazione commerciale e l'indirizzo geografico dell'organizzatore e, ove presente, del venditore, i
            loro recapiti telefonici e indirizzi di posta elettronica;</li>
          <li>il prezzo totale del pacchetto comprensivo di tasse e tutti i diritti, imposte e altri costi aggiuntivi,
            ivi comprese le eventuali spese amministrative e di gestione delle pratiche, oppure, ove questi non siano
            ragionevolmente calcolabili prima della conclusione del contratto, un'indicazione del tipo di costi
            aggiuntivi che il viaggiatore potrebbe dover ancora sostenere;</li>
          <li>le modalità di pagamento, compresi l'eventuale importo o percentuale del prezzo da versare a titolo di
            acconto e il calendario per il versamento del saldo, o le garanzie finanziarie che il viaggiatore è tenuto a
            pagare o fornire;</li>
          <li>il numero minimo di persone richiesto per il pacchetto e il termine di cui all'articolo 41, comma 5,
            lettera a), prima dell'inizio del pacchetto per l'eventuale risoluzione del contratto in caso di mancato
            raggiungimento del numero;</li>
          <li>le informazioni di carattere generale concernenti le condizioni in materia di passaporto e visti, compresi
            i tempi approssimativi per l'ottenimento dei visti e le formalità sanitarie del paese di destinazione;</li>
          <li>le informazioni sulla facoltà per il viaggiatore di recedere dal contratto in qualunque momento prima
            dell'inizio del pacchetto dietro pagamento di adeguate spese di recesso, o, se previste, delle spese di
            recesso standard richieste dall'organizzatore ai sensi dell'articolo 41, comma 1 CdT;</li>
          <li>le informazioni sulla sottoscrizione facoltativa o obbligatoria di un'assicurazione che copra le spese di
            recesso unilaterale dal contratto da parte del viaggiatore o le spese di assistenza, compreso il rientro, in
            caso di infortunio, malattia o decesso;</li>
          <li>gli estremi della copertura di cui all'articolo 47, commi 1, 2 e 3 CdT.</li>
        </ol>
        <p>
          Per i contratti di pacchetto turistico di cui all'articolo 33, comma 1, lettera d), stipulati per
          telefono, l'organizzatore o il professionista fornisce al viaggiatore le informazioni standard di cui
          all'allegato A, parte II, al presente decreto, e le informazioni di cui sopra.
        </p>

        <h3>6. Conclusione del Contratto di Pacchetto Turistico (Art. 36 CdT)</h3>
        <ol>
          <li>
            La proposta di compravendita di pacchetto turistico dovrà essere redatta su apposito modulo
            contrattuale, se del caso elettronico o, comunque, su supporto durevole, compilato in ogni sua parte e
            sottoscritto dal cliente, che ne riceverà copia. L'accettazione della proposta di compravendita del
            pacchetto turistico si intende perfezionata, con conseguente conclusione del contratto, solo nel
            momento in cui l'organizzatore invierà relativa conferma, anche a mezzo sistema telematico, al
            viaggiatore presso l'Agenzia di Viaggi venditrice, che ne curerà la consegna al viaggiatore medesimo.
            Le indicazioni relative al pacchetto turistico non contenute nei documenti contrattuali, negli
            opuscoli ovvero in altri mezzi di comunicazione scritta, saranno fornite dall'organizzatore, in
            regolare adempimento degli obblighi previsti a proprio carico dall'art. 36, comma 8, CdT, prima
            dell'inizio del viaggio.
          </li>
          <li>
            Le richieste particolari sulle modalità di erogazione e/o di esecuzione di taluni servizi facenti
            parte del pacchetto turistico, compresa la necessità di ausilio in aeroporto per persone con ridotta
            mobilità, la richiesta di pasti speciali a bordo o nella località di soggiorno, dovranno essere
            avanzate in fase di richiesta di prenotazione e risultare oggetto di specifico accordo tra Viaggiatore
            ed Organizzatore, per il tramite dell'Agenzia di Viaggi mandataria.
          </li>
          <li>
            In caso di contratti negoziati fuori dei locali commerciali, il viaggiatore ha diritto di recedere dal
            contratto di pacchetto turistico entro un periodo di cinque giorni dalla data della conclusione del
            contratto o dalla data in cui riceve le condizioni contrattuali e le informazioni preliminari se
            successiva, senza penali e senza fornire alcuna motivazione. Nei casi di offerte con tariffe
            sensibilmente diminuite rispetto alle offerte correnti, il diritto di recesso è escluso. In tale
            ultimo caso, l'organizzatore documenta la variazione di prezzo evidenziando adeguatamente l'esclusione
            del diritto di recesso (art. 41, comma 7, CdT).
          </li>
        </ol>

        <h3>7. Pagamenti</h3>
        <ol>
          <li>
            Se non diversamente indicato nell'informativa precontrattuale o nel contratto, all'atto della
            sottoscrizione della proposta di acquisto del pacchetto turistico dovrà essere corrisposta:
            <ol type="a">
              <li>la quota d'iscrizione o gestione pratica (vedi art. 8);</li>
              <li>
                acconto del prezzo del pacchetto turistico pubblicato in catalogo o nella quotazione del pacchetto
                fornita dall'Organizzatore. Il saldo dovrà essere improrogabilmente versato entro il termine
                stabilito dal Tour Operator nel proprio catalogo o nella conferma di prenotazione del
                servizio/pacchetto turistico richiesto.
              </li>
            </ol>
          </li>
          <li>
            Per le prenotazioni in epoca successiva alla data indicata quale termine ultimo per effettuare il
            saldo, l'intero ammontare dovrà essere versato al momento della sottoscrizione della proposta di
            acquisto.
          </li>
          <li>
            Il mancato pagamento delle somme di cui sopra, alle date stabilite, al pari della mancata rimessione
            al Tour Operator delle somme versate dal Viaggiatore all'Agenzia venditrice, e ferme le eventuali
            azioni di garanzia ex art. 47 CdT nei confronti di quest'ultimo, costituisce clausola risolutiva
            espressa ai sensi dell'art. 1456 cod. civ. tale da determinare la risoluzione di diritto da operarsi
            con semplice comunicazione scritta, via fax o via e-mail, presso l'Agenzia venditrice, o presso il
            domicilio anche elettronico, ove comunicato, del viaggiatore. Il saldo del prezzo si considera
            avvenuto quando le somme pervengono all'organizzatore direttamente dal viaggiatore o per il tramite
            dell'Agenzia di Viaggi intermediaria dal medesimo viaggiatore scelto.
          </li>
        </ol>

        <h3>8. Prezzo (Art. 39 CdT)</h3>
        <ol>
          <li>
            Il prezzo del pacchetto turistico è determinato nel contratto, con riferimento a quanto indicato in
            catalogo, o programma fuori catalogo ed agli eventuali aggiornamenti degli stessi cataloghi o
            programmi fuori catalogo successivamente intervenuti, o nel sito web dell'Operatore.
          </li>
          <li>
            Dopo la conclusione del contratto di pacchetto turistico, i prezzi possono essere aumentati di quanto
            indicato dall'Organizzatore, con un massimo dell'8% soltanto se il contratto lo preveda espressamente
            e precisi che il viaggiatore ha diritto a una corrispondente riduzione del prezzo, nonché le modalità
            di calcolo della revisione del prezzo. In tal caso, il viaggiatore ha diritto ad una riduzione del
            prezzo corrispondente alla diminuzione dei costi di cui al comma successivo, lettere a), b) e c), che
            si verifichi dopo la conclusione del contratto e prima dell'inizio del pacchetto.
          </li>
          <li>
            Gli aumenti di prezzo sono possibili esclusivamente in conseguenza di modifiche riguardanti:
            <ol type="a">
              <li>il prezzo del trasporto di passeggeri in funzione del costo del carburante o di altre fonti di
                energia;</li>
              <li>il livello di tasse o diritti sui servizi turistici inclusi nel contratto imposti da terzi non
                direttamente coinvolti nell'esecuzione del pacchetto, comprese le tasse di atterraggio, di sbarco ed
                imbarco nei porti e negli aeroporti;</li>
              <li>i tassi di cambio pertinenti al pacchetto.</li>
            </ol>
          </li>
          <li>Se l'aumento di prezzo di cui al presente articolo eccede l'8 per cento del prezzo complessivo del
            pacchetto, si applica l'articolo 40, commi 2, 3, 4 e 5 CdT.</li>
          <li>
            Un aumento di prezzo, indipendentemente dalla sua entità, è possibile solo previa comunicazione chiara
            e precisa su supporto durevole da parte dell'organizzatore al viaggiatore, unitamente alla
            giustificazione di tale aumento e alle modalità di calcolo, almeno venti giorni prima dell'inizio del
            pacchetto.
          </li>
          <li>In caso di diminuzione del prezzo, l'organizzatore ha diritto a detrarre le spese amministrative e di
            gestione delle pratiche effettive dal rimborso dovuto al viaggiatore, delle quali è tenuto a fornire la
            prova su richiesta del viaggiatore.</li>
        </ol>

        <h3>9. Modifica o Annullamento del Pacchetto Turistico Prima della Partenza (Art. 40 CdT)</h3>
        <ol>
          <li>
            Prima dell’inizio del pacchetto, l’organizzatore non può unilateralmente modificare le condizioni del
            contratto diverse da l prezzo ai sensi dell’articolo 39, salvo che si sia riservato tale diritto nel
            contratto e la modifica sia di scarsa importanza. L’organizzatore comunica la modifica al viaggiatore in
            modo chiaro e preciso su un supporto durevole.
          </li>
          <li>
            Se, prima dell'inizio del pacchetto, l’organizzatore è costretto a modificare in modo significativo una o
            più caratteristiche principali dei servizi turistici di cui all’articolo 34, comma 1, lettera a), o non può
            soddisfare le richieste specifiche di cui all’articolo 36, comma 5, lettera a), oppure propone di aumentare
            il prezzo del pacchetto di oltre l’8 per cento ai sensi dell’articolo 39, comma 3, il viaggiatore, entro un
            periodo ragionevole specificato dall'organizzatore, può accettare la modifica proposta oppure recedere dal
            contratto senza corrispondere spese di recesso. In caso di recesso, l'organizzatore può offrire al
            viaggiatore un pacchetto sostitutivo di qualità equivalente o superiore.
          </li>
          <li>
            L'organizzatore informa, senza ingiustificato ritardo, il viaggiatore in modo chiaro e preciso su un
            supporto durevole:
            <ol type="a">
              <li> delle modifiche proposte di cui al comma 2 e della loro incidenza sul prezzo del pacchetto ai sensi
                del comma 4;
              </li>
              <li>di un periodo ragionevole entro il quale il viaggiatore è tenuto a informare l’organizzatore della
                sua decisione ai sensi del comma 2;</li>
              <li>delle conseguenze della mancata risposta del viaggiatore entro il periodo di cui alla lettera b) e
                dell’eventuale pacchetto sostitutivo offerto e del relativo prezzo.</li>
            </ol>
          </li>
          <li> Se le modifiche del contratto di pacchetto turistico o del pacchetto sostitutivo di cui al comma 2
            comportano un pacchetto di qualità o costo inferiore, il viaggiatore ha diritto a un’adeguata riduzione del
            prezzo.</li>
          <li>
            In caso di recesso dal contratto di pacchetto turistico ai sensi del comma 2, se il viaggiatore non
            accetta un pacchetto sostitutivo, l’organizzatore rimborsa senza ingiustificato ritardo e in ogni caso entro
            quattordici giorni dal recesso dal contratto tutti i pagamenti effettuati da o per conto del viaggiatore e
            si applicano le disposizioni di cui all'articolo 43, commi 2, 3, 4, 5, 6, 7, 8 CdT.
          </li>
        </ol>

        <h3>10. Recesso del Viaggiatore (Art. 41 CdT)</h3>
        <ol>
          <li> Il viaggiatore può recedere dal contratto di pacchetto turistico in ogni momento prima dell’inizio del
            pacchetto, dietro rimborso all’organizzatore delle spese sostenute, adeguate e giustificabili, del cui
            ammontare quest’ultimo fornisce motivazione al viaggiatore che ne faccia richiesta.</li>
          <li> Il contratto di pacchetto turistico può prevedere penali standard per il recesso ragionevoli, calcolate
            in base al momento di recesso dal contratto e ai risparmi di costo attesi e agli introiti previsti che
            derivano dalla riallocazione dei servizi turistici.</li>
          <li> In assenza di specificazione delle penali standard di recesso, l’importo delle penali di recesso
            corrisponde al prezzo del pacchetto diminuito dei risparmi di costo e degli introiti che derivano dalla
            riallocazione dei servizi turistici.</li>
          <li>In caso di circostanze inevitabili e straordinarie verificatesi nel luogo di destinazione o nelle sue
            immediate vicinanze e che hanno un’incidenza sostanziale sull’esecuzione del pacchetto o sul trasporto di
            passeggeri verso la destinazione, il viaggiatore ha diritto di recedere dal contratto, prima dell’inizio del
            pacchetto, senza corrispondere spese di recesso, ed al rimborso integrale dei pagamenti effettuati per il
            pacchetto, ma non ha diritto a un indennizzo supplementare.</li>
          <li>
            L’organizzatore può recedere dal contratto di pacchetto turistico e offrire al viaggiatore il rimborso
            integrale dei pagamenti effettuati per il pacchetto, ma non è tenuto a versare un indennizzo supplementare
            se:
            <ol type="a">
              <li>il numero di persone iscritte al pacchetto è inferiore al minimo previsto dal contratto e
                l’organizzatore comunica il recesso dal contratto al viaggiatore entro il termine fissato nel contratto
                e in ogni caso non più tardi di venti giorni prima dell’inizio del pacchetto in caso di viaggi che
                durano più di sei giorni, di sette giorni prima dell’inizio del pacchetto in caso di viaggi che durano
                tra due e sei giorni, di quarantotto ore prima dell’inizio del pacchetto nel caso di viaggi che durano
                meno di due giorni;</li>
              <li>l’organizzatore non è in grado di eseguire il contratto a causa di circostanze inevitabili e
                straordinarie e comunica il recesso dal medesimo al viaggiatore senza ingiustificato ritardo prima
                dell’inizio del pacchetto.</li>
            </ol>
          </li>
          <li>L’organizzatore procede a tutti i rimborsi prescritti a norma dei commi 4 e 5 oppure, con riguardo a
            quanto previsto ai commi 1,2 e 3, rimborsa qualunque pagamento effettuato da o per conto del viaggiatore per
            il pacchetto dopo aver detratto le adeguate spese, senza ingiustificato ritardo e in ogni caso entro
            quattordici giorni dal recesso. Nei casi di cui ai commi 4 e 5, si determina la risoluzione dei contratti
            funzionalmente collegati stipulati con terzi.</li>
        </ol>

        <h3>11. Sostituzioni e Cessione del Pacchetto Turistico ad un Altro Viaggiatore (Art. 38 CdT)</h3>
        <ol>
          <li>Il viaggiatore, previo preavviso dato all'organizzatore su un supporto durevole entro e non oltre sette
            giorni prima dell'inizio del pacchetto, può cedere il contratto di pacchetto turistico a una persona che
            soddisfi tutte le condizioni per la fruizione del servizio.</li>
          <li>Il cedente e il cessionario del contratto di pacchetto turistico sono solidalmente responsabili per il
            pagamento del saldo del prezzo e degli eventuali diritti, imposte e altri costi aggiuntivi, ivi comprese le
            eventuali spese amministrative e di gestione delle pratiche, risultanti da tale cessione.</li>
          <li>L'organizzatore informa il cedente dei costi effettivi della cessione, che non possono essere
            irragionevoli e che non eccedano le spese realmente sostenute dall'organizzatore in conseguenza della
            cessione del contratto di pacchetto turistico, e fornisce al cedente la prova relativa ai diritti, alle
            imposte o agli altri costi aggiuntivi risultanti dalla cessione del contratto.</li>
          <li>In ogni caso il Viaggiatore che richieda la variazione di un elemento relativo ad una pratica già
            confermata, purché la richiesta non costituisca novazione contrattuale e sempre che ne risulti possibile
            l'attuazione, corrisponderà al Tour Operator, oltre alle spese conseguenti alla modifica stessa, un costo
            fisso forfetario.</li>
        </ol>

        <h3>12. Obblighi dei Viaggiatori</h3>
        <ol>
          <li>Nel corso delle trattative e comunque prima della conclusione del contratto, al Viaggiatore sono fornite
            per iscritto le informazioni di carattere generale concernenti i passaporti e i visti e le formalità
            sanitarie necessari per l'espatrio.</li>
          <li>Per le norme relative all'espatrio dei minori si rimanda espressamente a quanto indicato nel sito della
            <a href="http://www.poliziadistato.it/articolo/191/" target="_blank" rel="noopener"
              style="color: #1a73e8; text-decoration: underline;">Polizia di Stato</a>. Si precisa comunque che i
            minori devono essere in possesso di un documento personale
            valido per l'espatrio ovvero passaporto, o per i Paesi UE, anche di carta di identità valida per l'espatrio.
            Per quanto riguarda l'espatrio dei minori di anni 14 e l'espatrio di minori per i quali è necessaria
            l'Autorizzazione emessa dalla Autorità Giudiziaria, dovranno essere seguite le prescrizioni indicate sul
            sito della
            <a href="http://www.poliziadistato.it/articolo/191/" target="_blank" rel="noopener"
              style="color: #1a73e8; text-decoration: underline;">Polizia di Stato</a>.
          </li>
          <li>I viaggiatori dovranno reperire comunque le corrispondenti informazioni attraverso le loro rappresentanze
            diplomatiche e/o i rispettivi canali informativi governativi ufficiali. In ogni caso i viaggiatori
            provvederanno, prima della partenza, a verificarne l'aggiornamento presso le competenti autorità (per i
            cittadini italiani le locali Questure ovvero il Ministero degli Affari Esteri tramite il sito
            <a href="https://www.viaggiaresicuri.it" target="_blank" rel="noopener"
              style="color: #1a73e8; text-decoration: underline;">www.viaggiaresicuri.it</a> ovvero
            la Centrale Operativa Telefonica al numero 06.491115) adeguandovisi prima del
            viaggio. In assenza di tale verifica, nessuna responsabilità per la mancata partenza di uno o più
            viaggiatori potrà essere imputata all'Agenzia venditrice o all'organizzatore.
          </li>
          <li>I viaggiatori dovranno in ogni caso informare il venditore e l'organizzatore della propria cittadinanza al
            momento della richiesta di prenotazione del pacchetto turistico o servizio turistico e, al momento della
            partenza dovranno accertarsi definitivamente di essere muniti dei certificati di vaccinazione, del
            passaporto individuale e di ogni altro documento valido per tutti i Paesi toccati dall'itinerario, nonché
            dei visti di soggiorno, di transito e dei certificati sanitari che fossero eventualmente richiesti.</li>
          <li>Inoltre, al fine di valutare la situazione di sicurezza socio-politica, sanitaria e ogni altra
            informazione utile relativa ai Paesi di destinazione, il viaggiatore avrà l'onere di assumere le
            informazioni ufficiali di carattere generale presso il Ministero Affari Esteri, e divulgate attraverso il
            sito istituzionale della Farnesina
            <a href="https://www.viaggiaresicuri.it" target="_blank" rel="noopener"
              style="color: #1a73e8; text-decoration: underline;">www.viaggiaresicuri.it</a>. Le
            informazioni di cui sopra non sono contenute
            nei cataloghi dei T.O. poiché contengono informazioni descrittive di carattere generale e non temporalmente
            mutevoli; dovranno pertanto essere assunte a cura dei Viaggiatori, che dovranno inoltre attenersi
            all'osservanza delle regole di normale prudenza e diligenza ed a quelle specifiche in vigore nei paesi
            destinazione del viaggio, rispondendo di tutti i danni che l'organizzatore e/o il venditore dovessero subire
            a causa del mancato rispetto degli obblighi sopra indicati, ivi incluse le spese necessarie al loro
            rimpatrio.
          </li>
          <li>L'organizzatore o il venditore che abbia concesso un indennizzo o una riduzione di prezzo, ovvero
            corrisposto un risarcimento del danno o sia stato costretto ad ottemperare ad altri obblighi prescritti
            dalla Legge, ha il diritto di regresso nei confronti dei soggetti che abbiano contribuito al verificarsi
            delle circostanze o dell'evento da cui sono derivati tali obblighi, nonché dei soggetti tenuti a fornire
            servizi di assistenza ed alloggio, nel caso in cui il viaggiatore non possa rientrare nel luogo di partenza
            (art. 51 quinquies CdT).</li>
        </ol>

        <h3>13. Regime di Responsabilità dell'Organizzatore (Art. 42 CdT)</h3>

        <ol>
          <li>
            L'Organizzatore è responsabile dell’esecuzione dei servizi turistici previsti dal contratto di pacchetto
            turistico,
            indipendentemente dal fatto che tali servizi turistici devono essere prestati dall’organizzatore stesso, dai
            suoi
            ausiliari o preposti quando agiscono nell’esercizio delle loro funzioni, dai terzi della cui opera si avvale
            o da
            altri fornitori di servizi turistici, ai sensi dell'articolo 1228 del codice civile.
          </li>

          <li>
            Il viaggiatore, ai sensi degli articoli 1175 e 1375 del codice civile, informa l'Organizzatore, direttamente
            o tramite
            il venditore, tempestivamente, tenuto conto delle circostanze del caso, di eventuali difetti di conformità
            rilevati
            durante l’esecuzione di un servizio turistico previsto dal contratto di pacchetto turistico.
          </li>

          <li>
            Se uno dei servizi turistici non è eseguito secondo quanto pattuito nel contratto di pacchetto turistico,
            l’Organizzatore pone rimedio al difetto di conformità, a meno che ciò risulti impossibile oppure risulti
            eccessivamente oneroso, tenendo conto dell’entità del difetto di conformità e del valore dei servizi
            turistici
            interessati dal difetto. Se l’Organizzatore non pone rimedio al difetto, si applica l'articolo 43.
          </li>

          <li>
            Fatte salve le eccezioni di cui al comma 3, se l’Organizzatore non pone rimedio al difetto di conformità
            entro un
            periodo ragionevole fissato dal viaggiatore in relazione alla durata e alle caratteristiche del pacchetto,
            con la
            contestazione effettuata ai sensi del comma 2, il viaggiatore può ovviare personalmente al difetto e
            chiedere il
            rimborso delle spese necessarie, ragionevoli e documentate; se l’Organizzatore rifiuta di porre rimedio al
            difetto di
            conformità o se è necessario ovviarvi immediatamente non occorre che il viaggiatore specifichi un termine.
          </li>

          <li>
            Se un difetto di conformità, ai sensi dell’articolo 1455 del codice civile, costituisce un inadempimento di
            non scarsa
            importanza dei servizi turistici inclusi in un pacchetto e l’Organizzatore non vi ha posto rimedio entro un
            periodo
            ragionevole stabilito dal viaggiatore in relazione alla durata e alle caratteristiche del pacchetto, con la
            contestazione effettuata ai sensi del comma 2, il viaggiatore può, senza spese, risolvere di diritto e con
            effetto
            immediato il contratto di pacchetto turistico o, se del caso, chiedere, ai sensi dell'articolo 43, una
            riduzione del
            prezzo, salvo comunque l'eventuale risarcimento dei danni. In caso di risoluzione del contratto, se il
            pacchetto
            comprendeva il trasporto dei passeggeri, l’Organizzatore provvede anche al rientro del viaggiatore con un
            trasporto
            equivalente senza ingiustificato ritardo e senza costi aggiuntivi per il viaggiatore.
          </li>

          <li>
            Laddove è impossibile assicurare il rientro del viaggiatore, l’Organizzatore sostiene i costi dell’alloggio
            necessario, ove possibile di categoria equivalente a quanto era previsto dal contratto, per un periodo non
            superiore
            a tre notti per viaggiatore o per il periodo più lungo eventualmente previsto dalla normativa dell’Unione
            europea
            relativa ai diritti dei passeggeri, applicabile ai pertinenti mezzi di trasporto.
          </li>

          <li>
            La limitazione dei costi di cui al comma 6 non si applica alle persone a mobilità ridotta, definite
            dall’articolo 2,
            paragrafo 1, lettera a), del regolamento (CE) n. 1107/2006, e ai loro accompagnatori, alle donne in stato di
            gravidanza, ai minori non accompagnati e alle persone bisognose di assistenza medica specifica, purché
            l’Organizzatore abbia ricevuto comunicazione delle loro particolari esigenze almeno quarantotto ore prima
            dell’inizio
            del pacchetto. L’Organizzatore non può invocare circostanze inevitabili e straordinarie per limitare la
            responsabilità di cui al presente comma qualora il fornitore del servizio di trasporto non possa far valere
            le
            stesse circostanze ai sensi della normativa dell’Unione europea applicabile.
          </li>

          <li>
            Se per circostanze sopravvenute non imputabili all’Organizzatore è impossibile fornire, in corso
            d’esecuzione, una
            parte sostanziale, per valore o qualità, della combinazione dei servizi turistici pattuiti nel contratto di
            pacchetto
            turistico, l’Organizzatore offre, senza supplemento di prezzo a carico del viaggiatore, soluzioni
            alternative adeguate
            di qualità, ove possibile equivalente o superiore, rispetto a quelle specificate nel contratto, affinché
            l’esecuzione
            del pacchetto possa continuare, inclusa l’eventualità che il ritorno del viaggiatore al luogo di partenza
            non sia
            fornito come concordato. Se le soluzioni alternative proposte comportano un pacchetto di qualità inferiore
            rispetto a
            quella specificata nel contratto di pacchetto turistico, l’Organizzatore concede al viaggiatore un’adeguata
            riduzione
            del prezzo.
          </li>

          <li>
            Il viaggiatore può respingere le soluzioni alternative proposte solo se non sono comparabili a quanto
            convenuto nel
            contratto di pacchetto turistico o se la riduzione del prezzo concessa è inadeguata.
          </li>

          <li>
            Se è impossibile predisporre soluzioni alternative o il viaggiatore respinge le soluzioni alternative
            proposte,
            conformi a quanto indicato dal comma 8, al viaggiatore è riconosciuta una riduzione del prezzo. In caso di
            inadempimento dell’obbligo di offerta di cui al comma 8 si applica il comma 5.
          </li>

          <li>
            Laddove, a causa di circostanze sopravvenute non imputabili all’Organizzatore, è impossibile assicurare il
            rientro del
            viaggiatore come pattuito nel contratto di pacchetto turistico, si applicano i commi 6 e 7.
          </li>
        </ol>


        <h3>14. Regime di Responsabilità del Venditore (Artt. 50 - 51 quater CdT)</h3>
        <ol>
          <li>Il Venditore è responsabile dell'esecuzione del mandato conferitogli dal viaggiatore con il contratto di
            intermediazione di viaggio, indipendentemente dal fatto che la prestazione sia resa dal venditore stesso,
            dai suoi ausiliari o preposti quando agiscono nell'esercizio delle loro funzioni o dai terzi della cui opera
            si avvalga, dovendo l'adempimento delle obbligazioni assunte essere valutato con riguardo alla diligenza
            richiesta per l'esercizio della corrispondente attività professionale.</li>
          <li>Il Venditore non è responsabile degli errori di prenotazione imputabili al viaggiatore o dovuti a
            circostanze inevitabili e straordinarie.</li>
          <li>Il diritto del viaggiatore al risarcimento dei danni collegati alla responsabilità del Venditore si
            prescrive in due anni a decorrere dalla data del rientro del viaggiatore nel luogo di partenza.</li>
        </ol>

        <h3>15. Limiti del Risarcimento (Art. 43, comma 5)</h3>
        <p>
          Il contratto di pacchetto turistico può prevedere la limitazione del risarcimento dovuto
          dall'organizzatore, salvo che per i danni alla persona o quelli causati intenzionalmente o per colpa,
          purché tale limitazione non sia inferiore al triplo del prezzo totale del pacchetto.
        </p>
        <p>
          Il diritto al risarcimento dei danni alla persona si prescrive in tre anni a decorrere dalla data del
          rientro del viaggiatore nel luogo di partenza o nel più lungo periodo previsto per il risarcimento del
          danno alla persona dalle disposizioni che regolano i servizi compresi nel pacchetto.
        </p>

        <h3>16. Possibilità di Contattare l'Organizzatore Tramite il Venditore (Art. 44 CdT)</h3>
        <ol>
          <li>Il Viaggiatore può indirizzare messaggi, richieste o reclami relativi all'esecuzione del pacchetto
            direttamente al Venditore tramite il quale l'ha acquistato, il quale, a propria volta, inoltra
            tempestivamente tali messaggi, richieste o reclami all'Organizzatore.</li>
          <li>Ai fini del rispetto dei termini o dei periodi di prescrizione, la data in cui il venditore riceve
            messaggi, richieste o reclami di cui al comma precedente è considerata la data di ricezione anche per
            l'Organizzatore.</li>
        </ol>

        <h3>17. Obbligo di Assistenza (Art. 45 CdT)</h3>
        <ol>
          <li>L'organizzatore presta adeguata assistenza senza ritardo al viaggiatore che si trova in difficoltà,anche
            nelle circostanze di cui all'articolo 42, comma 7 CdT, in
            particolare fornendo le opportune informazioni riguardo ai servizi sanitari, alle autorità locali e
            all'assistenza consolare e assistendo il viaggiatore nell'effettuare comunicazioni a distanza e aiutandolo a
            trovare servizi turistici alternativi.</li>
          <li>L'organizzatore può pretendere il pagamento di un costo ragionevole per tale assistenza qualora il
            problema sia causato intenzionalmente dal viaggiatore o per sua colpa, nei limiti delle spese effettivamente
            sostenute.</li>
        </ol>

        <h3>18. Assicurazione Contro le Spese di Annullamento e di Rimpatrio (Art. 47, comma 10 CdT)</h3>
        <p>
          Se non espressamente comprese nel prezzo, è possibile e consigliabile stipulare, al momento della
          prenotazione e tramite il Venditore, speciali polizze assicurative contro le spese derivanti
          dall'annullamento del pacchetto, dagli infortuni e/o malattie che coprano anche le spese di rimpatrio e
          dalla perdita e/o danneggiamento del bagaglio. I diritti nascenti dai contratti di assicurazione devono
          essere esercitati dal viaggiatore direttamente nei confronti delle Compagnie di Assicurazione
          stipulanti, alle condizioni e con le modalità previste nelle polizze medesime, come esposto nelle
          condizioni di polizza pubblicate sui cataloghi o esposte negli opuscoli messi a disposizione dei
          Viaggiatori al momento della partenza.
        </p>

        <h3>19. Strumenti Alternativi di Risoluzione delle Controversie (Art. 36, comma 5, lett. g) CdT)</h3>
        <p>
          L'organizzatore potrà proporre al viaggiatore - sul catalogo, sulla documentazione, sul proprio sito
          internet o in altre forme - modalità di risoluzione alternativa delle contestazioni insorte (ADR -
          Alternative Dispute Resolution), ai sensi del D.Lgs. 206/2005. In tal caso l'organizzatore indicherà la
          tipologia di risoluzione alternativa proposta e gli effetti che tale adesione comporta.
        </p>

        <h3>20. Protezione del Viaggiatore (Art. 47 CdT)</h3>
        <ol>
          <li>L'organizzatore e il venditore stabiliti sul territorio nazionale sono coperti da contratto di
            assicurazione per la responsabilità civile a favore del viaggiatore per il risarcimento dei danni derivanti
            dalla violazione dei rispettivi obblighi assunti con i rispettivi contratti.</li>
          <li>I contratti di organizzazione di pacchetto turistico sono assistiti da polizze assicurative o garanzie
            bancarie o emesse dai Fondi di cui al comma 3 dell'art. 47 del CdT, che, per i viaggi all'estero e i viaggi
            che si svolgono all'interno di un singolo Paese, ivi compresi i viaggi in Italia, nei casi di insolvenza o
            fallimento dell'organizzatore o del venditore garantiscono, senza ritardo su richiesta del viaggiatore, il
            rimborso del prezzo versato per l'acquisto del pacchetto e il rientro immediato del viaggiatore nel caso in
            cui il pacchetto include il trasporto del viaggiatore, nonché, se necessario, il pagamento del vitto e
            dell'alloggio prima del rientro. La garanzia è effettiva, adeguata al volume di affari e copre i costi
            ragionevolmente prevedibili, gli importi dei pagamenti effettuati da o per conto dei viaggiatori in
            relazione a pacchetti, tenendo conto della durata del periodo compreso tra gli acconti e il saldo finale e
            del completamento dei pacchetti, nonché del costo stimato per i rimpatri in caso di insolvenza o fallimento
            dell'organizzatore o del venditore.</li>
          <li>I viaggiatori beneficiano della protezione in caso d'insolvenza o fallimento dell'organizzatore o del
            venditore indipendentemente dal loro luogo di residenza, dal luogo di partenza o dal luogo di vendita del
            pacchetto e indipendentemente dallo Stato membro in cui è stabilito il soggetto incaricato di fornire
            protezione in caso di insolvenza o fallimento.</li>
          <li>Nei casi previsti dal comma 2, in alternativa al rimborso del prezzo o al rientro immediato, può essere
            offerta al viaggiatore la continuazione del pacchetto con le modalità di cui agli articoli 40 e 42 CdT.</li>
        </ol>

        <h3>21. Modifiche Operative</h3>
        <p>
          In considerazione del largo anticipo con cui vengono pubblicati i cataloghi che riportano le
          informazioni relative alle modalità di fruizione dei servizi, si rende noto che gli orari e le tratte
          dei voli indicati nella accettazione della proposta di compravendita dei servizi potrebbero subire
          variazioni poiché soggetti a successiva convalida. A tal fine il viaggiatore dovrà chiedere conferma dei
          servizi alla propria Agenzia di Viaggi prima della partenza. L'Organizzatore informerà i passeggeri
          circa l'identità del vettore effettivo nei tempi e con le modalità previste dall'art. 11 del Reg. CE
          2111/2005.
        </p>

        <h3>22. Informativa Privacy (Art. 13 D. Lgs. 196/2003 e Art. 13 Regolamento UE 2016/679)</h3>
        <p>
          Ai sensi dell'art. 13 del D. Lgs. 196/2003 ("Codice Privacy") e dell'art. 13 del Regolamento (UE)
          2016/679, recante disposizioni a tutela delle persone e di altri soggetti rispetto al trattamento dei
          dati personali, si informa che i dati personali forniti formeranno oggetto di trattamento nel rispetto
          della normativa sopra richiamata e degli obblighi di riservatezza cui è tenuta la scrivente Società.
        </p>

        <h3>23. Comunicazione Obbligatoria ai Sensi dell'Articolo 17 della Legge n. 38/2006</h3>
        <p>
          "La legge italiana punisce con la reclusione i reati concernenti la prostituzione e la pornografia
          minorile, anche se commessi all'estero".
        </p>
      </section>
    </div>
  </ng-template>
</p-dialog>

<!-- <p-dialog
  header="Termini e condizioni"
  [modal]="true"
  [(visible)]="insuranceTextDialog"
  [style]="{ width: '50rem' }"
  [draggable]="false"
>
  <div [innerHTML]="travel?.terms_and_conds">

  </div>
</p-dialog> -->
<!-- <pre>{{ bookingDate | date: "dd/MM/yyyy" }}</pre> -->
<!-- <pre>{{ frmJoin.value | json }}</pre> -->